import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const formatINR = (n) =>
  Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const safe = (v) => (v === null || v === undefined ? "" : String(v));

export default function PartPaymentPrint() {
  const location = useLocation();
  const navigate = useNavigate();

  const customer = location.state?.customer;  // ✅ full customer (formData)
  const payment = location.state?.payment;    // ✅ selected payment row
  // const payments = location.state?.payments; // optional if you want

  useEffect(() => {
    // If print page opened directly or refreshed, state will be missing
    if (!customer || !payment) {
      navigate(-1);
      return;
    }

    // Auto print
    setTimeout(() => {
      window.print();
      // window.close(); // enable only if opened by new tab
    }, 300);
  }, [customer, payment, navigate]);

  if (!customer || !payment) return null;

  // Map from your Entry formData + payment row keys
  const billNo = payment.billno || "";
  const receiptDate = payment.date || "";
  const payingAmount = payment.amount || 0;
  const balanceAfter = payment.balanceAfter ?? customer.balanceAmountAfterPayment ?? 0;

  const billedAmount =
    customer.billedAmount || customer.valueOfAsset || 0;

  const balanceBefore =
    customer.balanceAmount || billedAmount || 0;

  return (
    <div style={{ padding: 18, fontFamily: "Arial, sans-serif" }}>
      <div style={{ border: "1px solid #222", padding: 12 }}>
        {/* Header */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "130px 1fr 160px",
            gap: 10,
            alignItems: "center",
            borderBottom: "1px solid #222",
            paddingBottom: 10,
          }}
        >
          <div style={{ border: "1px solid #222", width: 120, height: 70, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12 }}>
            LOGO
          </div>

          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: 700, fontSize: 20 }}>Nissi Infotech</div>
            <div style={{ fontWeight: 700, marginTop: 2 }}>Nissi</div>
            <div style={{ fontSize: 12, marginTop: 3 }}>
              3/42-12, Nagappa colony, kavundampalayam - 641030, Tamil Nadu, India
            </div>
            <div style={{ fontSize: 12, marginTop: 3 }}>
              Phone No: 9003744644 &nbsp; | &nbsp; Email: infraconsoft-implementation@nissiinfotech
            </div>
          </div>

          <div style={{ textAlign: "center", fontWeight: 700, borderLeft: "1px solid #222", paddingLeft: 10 }}>
            Payment <br /> Receipt
          </div>
        </div>

        <div style={{ textAlign: "center", fontWeight: 700, margin: "14px 0 10px" }}>
          Part Payment
        </div>

        {/* Details */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30, fontSize: 13 }}>
          <div>
            <div style={{ margin: "7px 0" }}><b>Bill No</b> : {safe(billNo)}</div>
            <div style={{ margin: "7px 0" }}><b>Customer ID</b> : {safe(customer.customerId)}</div>
            <div style={{ margin: "7px 0" }}><b>Customer Name</b> : {safe(customer.customerName)}</div>
            <div style={{ margin: "7px 0" }}><b>Product Name</b> : {safe(customer.productName)}</div>
            <div style={{ margin: "7px 0" }}><b>Sales Person</b> : {safe(customer.salesPerson)}</div>
          </div>

          <div>
            <div style={{ margin: "7px 0" }}><b>Plot No / Asset Code</b> : {safe(customer.plotNoAssetCode)}</div>
            <div style={{ margin: "7px 0" }}><b>Location</b> : {safe(customer.location)}</div>
            <div style={{ margin: "7px 0" }}><b>Date of Booking</b> : {safe(customer.dateOfAcquisition)}</div>
            <div style={{ margin: "7px 0" }}><b>Asset Value</b> : {formatINR(customer.valueOfAsset || billedAmount)}</div>
            <div style={{ margin: "7px 0" }}><b>Payment Mode</b> : {safe(payment.paymentMode || customer.paymentMode)}</div>
            <div style={{ margin: "7px 0" }}><b>Status</b> : {safe(payment.status)}</div>
            <div style={{ margin: "7px 0" }}><b>Next Payment Date</b> : {safe(payment.nextPaymentDate || customer.nextPaymentDate)}</div>
          </div>
        </div>

        {/* Table */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
          <table style={{ width: "85%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid #222", padding: 8, width: 70 }}>S.No</th>
                <th style={{ border: "1px solid #222", padding: 8, width: 160 }}>Date</th>
                <th style={{ border: "1px solid #222", padding: 8 }}>Description</th>
                <th style={{ border: "1px solid #222", padding: 8, width: 170 }}>₹</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td style={{ border: "1px solid #222", padding: 8, textAlign: "center" }}>1</td>
                <td style={{ border: "1px solid #222", padding: 8, textAlign: "center" }}>{safe(receiptDate)}</td>
                <td style={{ border: "1px solid #222", padding: 8 }}>
                  <div style={{ padding: "7px 0", borderBottom: "1px solid #ddd" }}><b>Billed Amount</b></div>
                  <div style={{ padding: "7px 0", borderBottom: "1px solid #ddd" }}><b>Balance Amount</b></div>
                  <div style={{ padding: "7px 0", borderBottom: "1px solid #ddd" }}><b>Paying Amount</b></div>
                  <div style={{ padding: "7px 0" }}><b>Balance amount After Payment</b></div>
                </td>
                <td style={{ border: "1px solid #222", padding: 8, textAlign: "right" }}>
                  <div style={{ padding: "7px 0", borderBottom: "1px solid #ddd" }}>{formatINR(billedAmount)}</div>
                  <div style={{ padding: "7px 0", borderBottom: "1px solid #ddd" }}>{formatINR(balanceBefore)}</div>
                  <div style={{ padding: "7px 0", borderBottom: "1px solid #ddd" }}>{formatINR(payingAmount)}</div>
                  <div style={{ padding: "7px 0" }}>{formatINR(balanceAfter)}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{ marginTop: 18, display: "flex", justifyContent: "space-between", fontSize: 12 }}>
          <div>{new Date().toLocaleDateString("en-GB")}</div>
          <div style={{ fontWeight: 700 }}>Authorized Signatory</div>
        </div>
      </div>

      <style>{`
        @media print {
          body { margin: 0; }
        }
      `}</style>
    </div>
  );
}
